export const SET_IS_LOADING = 'COMISSIONED_LIST/SET_IS_LOADING';
export const SET_COMISSIONED_LIST = 'COMISSIONED_LIST/SET_COMISSIONED_LIST';
export const SET_COMISSIONED_LIST_ALL = 'COMISSIONED_LIST/SET_COMISSIONED_LIST_ALL';
export const SET_COMISSIONED_FILTERS = 'COMISSIONED_LIST/SET_COMISSIONED_FILTERS';
export const CLEAR_COMISSIONED_LIST = 'COMISSIONED_LIST/CLEAR_COMISSIONED_LIST';